import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from "src/components/Common/TableContainer";
import { useNavigate } from "react-router";
import ModalValidation from "../../Forms/FormValidation/financing/ModalValidation";
import { useSelector, useDispatch } from "react-redux";
import useToast from "src/components/Common/toast";
import { getProjectFinanciers } from "src/slices/Projects/thunk";


const Financiers = ({ project }: any) => {
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [financingList, setFinancingList] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { show, ToastComponent } = useToast();
  const [successDelete, setSuccessDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState(false);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);

  useEffect(() => {
    if (errorDelete) {
      show("Erro", "Erro ao apagar o financiamento.");
      setErrorDelete(false);
    } else if (successDelete) {
      show("Sucesso", "Financiamento apagado com sucesso.");
      setSuccessDelete(false);
    } else if (errorUpdate) {
      show("Erro", "Erro ao actualizar o financiamento.");
      setErrorUpdate(false);
    } else if (successUpdate) {
      show("Sucesso", "Financiamento actualizado com sucesso.");
      setSuccessUpdate(false);
    }
  }, [successDelete, errorDelete, successUpdate, errorUpdate]);

  const financing = useSelector((state: any) => state.financing.financing);

  const toggle = () => {
    setModal(!modal);
  };

  const handleRowClick = (arg: any) => {
    const financing = arg;
    setFinancingList({
      id: financing.id,
      name: financing.nome,
      valor_previsto: financing.valor_previsto,
      descricao: financing.descricao,
    });
    setIsEdit(true);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Financiador",
        accessor: "financier_name",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Montante",
        accessor: "amount",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Moeda",
        accessor: "moeda",
        disableFilters: true,
        filterable: true,
      },      
    ],
    []
  );

  return (
    <React.Fragment>
      {ToastComponent}
      <Card>
        <CardBody>                
          <TableContainer
            addButtonLabel="Novo Financiamento"
            columns={columns}
            data={project.proveniencia_fundo}
            isGlobalFilter={false}
            isAddUserList={true}
            isOptionalAdd={true}
            customPageSize={10}
            className="custom-header-css"
            handleUserClick={() => {
              navigate("/projects/financing/create");
            }}
            handleRowClick={handleRowClick}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Financiers;
